import { Outlet } from "react-router";
import { NavLink } from "react-router";
import HeaderNav from './Header'
import LeftMenu from './LeftMenu'
import Footer from './Footer'
// import C1 from '../assets/images/c1.jpg'
// import C2 from '../assets/images/c2.jpg'
// import C3 from '../assets/images/c3.jpg'
import Hero from '../assets/images/2 Image.png'
import Brochure from "../assets/images/IETBHEC27_Brochure.png"

function Layout_About() {
    return (
        <>
            <div className="super_container">

                <div id="mySidenav" className="sidenav">
                    <LeftMenu />
                </div>

                <div className="home">
                    <HeaderNav />
                </div>

                <div className='hero-flex-box'>
                    <div className="hero-flex-left">
                        <h3><strong>International Engineering, Technology, Business and Health Education Conference IETBHEC’27</strong></h3>
                        <p><strong>(5th International Engineering and Technology Education Conference - IETEC)</strong></p>
                        <p><strong>Da Nang, Vietnam | 25 - 27 February 2027</strong></p>
                        <NavLink to="/registration"><button id='hero-button'>Register</button></NavLink>
                        <br></br>
                        <br></br>
                        <p><strong>Conference Brochure: </strong><a href={Brochure} target='_blank' rel="noreferrer noopener">IETBHEC27_Brochure</a></p>
                    </div>
                    <div className="hero-flex-right">
                        <img src={Hero} className="d-block w-100 carousel-img" alt="..." height="350vh"/>
                    </div>
                </div>

                <div className="content_about">
                    <Outlet />
                </div>

                <div>
                    <Footer />
                </div>
            </div >
        </>
    )
}

export default Layout_About